export enum AppHtmlId {
    LOADING = 'sails-loading-spinner',
    ACCORDION_FAQ = 'faq-accordion',
    ACCORDION_COMISSION = 'content-beauftragung',
    ACCORDION_CONNECTION = 'content-glasfaser-anschluss',
    ACCORDION_COST = 'content-kosten',
    DYNAMIC_FOOTNOTE = 'fiber-footnote-accordion',
    APP_CONTAINER = 'fiber-app-container',
    ERROR = 'fiber-service-error',
    RELATED_LINKS_OFFERS = 'fiber-related-links-offers',
    RELATED_LINKS_GENERAL = 'fiber-related-links',
    NOTIFICATION_BUTTON_CONTAINER = 'floating-mobile-notification',
    NOTIFICATION_BUTTON = 'floatin-notification-button',
    OFFER_SUMMARY_CARD = 'fixnet-offer-summary-card',
    FIXNET_WHOLYBUY_CARD = 'fixnet-wholybuy-card',
    LINEAR_STEPPER = 'fixnet-linear-stepper',
}

export enum OfferSummaryCardHtmlId {
    TARIFF_SUBLINE_TOOLTIP = 'fiber-selected-tariff-subline-tooltip',
    INSTALLATION_FEE_TEXT_TOOLTIP = 'fiber-additional-text-tooltip',
}

export enum TariffHtmlId {
    TARIFF_PICKER = 'fiber-tariff-picker',
    BENEFITS = 'fiber-tariff-benefits',
    BENEFITS_LIST = 'fiber-tariff-benefits-list',
    LINKS_LIST = 'fiber-tariff-links-list',
    FASTEST_HIGHLIGHT_BADGE = 'fastest-highlight-badge',
}

export enum AvcHtmlId {
    CHECK_CONTAINER = 'fiber-avc-container',
    RESULT_CONTAINER = 'fiber-avc-result-container'
}

export enum AddressHtmlId {
    ADDRESS_WRAPPER = 'fiber-checked-address',
    ADDRESS_TEXT = 'fiber-avc-address',
    CHANGE_ADDRESS = 'fiber-change-address-button',
    DELETE_ADDRESS = 'fiber-delete-address-button'
}

export enum ResultHtmlId {
    NOTIFICATION = 'avc-notification',
    ALTERNATIVE_TEXT = 'avc-alternative-text',
    BUTTON = 'avc-button',
    CHECKED_ADDRESS = 'avc-checked-address',
    TOOLTIP = 'avc-regiofee-tooltip',
    CHANGE_ADDRESS = 'avc-change-address-button',
    LM_BUTTON = 'avc-lm-form-open-button'
}

export enum FormId {
    FORM = 'avc-form',
    CITY = 'wrapper-input-avc-city',
    STREET = 'wrapper-input-avc-street',
    NUMBER = 'wrapper-input-avc-house',
    SUBMIT = 'wrapper-btn-address-form',
    LOADING = 'avc-loading-spinner',
    SELECT_CONTAINER = 'avc-select-container',
    SELECT = 'avc-select-wrapper',
    TOOLTIP = 'avc-subline-tooltip',
    ADDRESS_ERROR = 'avc-address-error',
    SERVICE_ERROR = 'avc-service-error'
}

export type HtmlId = AppHtmlId |
    OfferSummaryCardHtmlId |
    TariffHtmlId |
    AddressHtmlId |
    ResultHtmlId |
    AvcHtmlId |
    FormId;

export enum OverlayContent {
    FORM = 'avc-address-form',
    CAPTCHA = 'avc-captcha',
    RESULT = 'avc-result-container',
}
